export interface ExportProperty {
  property: {
    id: string;
    displayName: {
      [lang: string]: string;
    };
    type: 'root' | 'group' | 'specific';
    additionalInformation?: {
      requiredFeaturePermission: `${string}:${string}`[];
    };
  };
  children: ExportProperty[];
}

export class ExportProperties {
  public static findById(
    properties: ExportProperty[],
    propertyId: string,
  ): ExportProperty | undefined {
    let result: ExportProperty;
    properties.forEach((property) => {
      const prop = this._findSingleById(property, propertyId);
      if (prop) {
        result = prop;
      }
    });

    return result;
  }

  public static findParentById(
    exportProperty: ExportProperty,
    propertyId: string,
  ): ExportProperty | undefined {
    if (!exportProperty.children) {
      return undefined;
    }

    for (const child of exportProperty.children) {
      if (child.property.id === propertyId) {
        return exportProperty;
      }

      const found = this.findParentById(child, propertyId);
      if (found) {
        return found;
      }
    }

    return undefined;
  }

  private static _findSingleById(
    property: ExportProperty,
    propertyId: string,
  ): ExportProperty | undefined {
    if (property.property.id === propertyId) {
      return property;
    } else if (property.children && property.children.length > 0) {
      return this.findById(property.children, propertyId);
    } else {
      return undefined;
    }
  }
}
